// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-row.wrapper {
  align-items: center;
  padding: 3px 13px 4px;
  background-color: #fff;
  border: 0.5px solid rgba(235, 228, 222, 0.5);
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
}
ion-row.wrapper ion-icon {
  cursor: pointer;
}
ion-row.wrapper.active {
  padding: 0;
}
ion-row.wrapper.inactive {
  height: auto;
  padding: 8px;
}
ion-row.wrapper p {
  margin: 0;
  line-height: 90%;
}
ion-row.wrapper .hint {
  display: block;
  font-family: AppFont;
  font-size: 10px;
  line-height: 12px;
  text-align: left;
  color: #000;
}

.white-rounded-square {
  border-radius: 4px;
  color: var(--ion-color-secondary);
  fill: var(--ion-color-secondary);
}

ion-item {
  --border-radius: 4px;
  display: block;
  margin-bottom: 0;
  --min-height: 44px;
}
ion-item ion-label {
  color: #000;
  position: relative;
  margin-left: 20px;
  font-family: AppFont;
  font-size: 10px;
  text-align: left;
}
ion-item ion-input {
  color: black;
  --padding-top: 0px;
  --padding-bottom: 0px;
}
ion-item ion-input.has-error {
  color: #ef5231;
}

.delete-promo {
  margin-left: 5px;
}

.submit-button {
  background: var(--ion-color-secondary);
  border-radius: 4px;
  place-self: center;
  margin: 0;
}

.reg-row {
  width: 100%;
  color: var(--ion-color-secondary);
}
.reg-row__btn {
  flex: 1;
  border-radius: 5px;
  font-size: 16px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
}
.reg-row__btn:first-child {
  margin-right: 8px;
}
.reg-row__btn:last-child {
  margin-left: 8px;
}

ion-spinner {
  display: block;
  margin: 10px auto;
}

.promo-input {
  --padding-start: 20px;
}

.wraper_name {
  padding-bottom: 15px;
  border-bottom: 2.55px dotted black;
  margin-bottom: 10px;
}
.wraper_name .name {
  font-size: 14px;
  line-height: 20px;
}
.wraper_name .discount {
  font-family: SecondFontBold, sans-serif;
  font-size: 14px;
  line-height: 20px;
}

.title {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 15px;
  text-align: left;
  color: #000;
}

.promo-icon-button {
  height: 20px;
  width: 20px;
  padding: 5px;
  border: 2px solid red;
}

.border-line {
  border: 1px solid #000000;
}`, "",{"version":3,"sources":["webpack://./src/app/components/promo-code/promo-code.component.scss"],"names":[],"mappings":"AAAA;EACC,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,4CAAA;EACA,2CAAA;AACD;AACC;EACC,eAAA;AACF;AAEC;EACC,UAAA;AAAF;AAGC;EACC,YAAA;EACA,YAAA;AADF;AAIC;EACC,SAAA;EACA,gBAAA;AAFF;AAKC;EACC,cAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,WAAA;AAJF;;AAQA;EACC,kBAAA;EACA,iCAAA;EACA,gCAAA;AALD;;AAQA;EACC,oBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AALD;AAOC;EACC,WAAA;EACA,kBAAA;EACA,iBAAA;EAEA,oBAAA;EACA,eAAA;EAEA,gBAAA;AAPF;AAUC;EACC,YAAA;EACA,kBAAA;EACA,qBAAA;AARF;AAWE;EACC,cAAA;AATH;;AAcA;EACC,gBAAA;AAXD;;AAcA;EACC,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAXD;;AAcA;EACC,WAAA;EACA,iCAAA;AAXD;AAaC;EACC,OAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAXF;AAaE;EACC,iBAAA;AAXH;AAcE;EACC,gBAAA;AAZH;;AAiBA;EACC,cAAA;EACA,iBAAA;AAdD;;AAiBA;EACC,qBAAA;AAdD;;AAiBA;EACC,oBAAA;EACA,kCAAA;EACA,mBAAA;AAdD;AAgBC;EACC,eAAA;EACA,iBAAA;AAdF;AAiBC;EACC,uCAAA;EACA,eAAA;EACA,iBAAA;AAfF;;AAmBA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,WAAA;AAjBD;;AAoBA;EACC,YAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AAjBD;;AAmBA;EACC,yBAAA;AAhBD","sourcesContent":["ion-row.wrapper {\n\talign-items: center;\n\tpadding: 3px 13px 4px;\n\tbackground-color: #fff;\n\tborder: 0.5px solid rgba(235, 228, 222, 0.5);\n\tbox-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);\n\n\tion-icon {\n\t\tcursor: pointer;\n\t}\n\n\t&.active {\n\t\tpadding: 0;\n\t}\n\n\t&.inactive {\n\t\theight: auto;\n\t\tpadding: 8px;\n\t}\n\n\tp {\n\t\tmargin: 0;\n\t\tline-height: 90%;\n\t}\n\n\t.hint {\n\t\tdisplay: block;\n\t\tfont-family: AppFont;\n\t\tfont-size: 10px;\n\t\tline-height: 12px;\n\n\t\ttext-align: left;\n\t\tcolor: #000;\n\t}\n}\n\n.white-rounded-square {\n\tborder-radius: 4px;\n\tcolor: var(--ion-color-secondary);\n\tfill: var(--ion-color-secondary);\n}\n\nion-item {\n\t--border-radius: 4px;\n\tdisplay: block;\n\tmargin-bottom: 0;\n\t--min-height: 44px;\n\n\tion-label {\n\t\tcolor: #000;\n\t\tposition: relative;\n\t\tmargin-left: 20px;\n\n\t\tfont-family: AppFont;\n\t\tfont-size: 10px;\n\n\t\ttext-align: left;\n\t}\n\n\tion-input {\n\t\tcolor: black;\n\t\t--padding-top: 0px;\n\t\t--padding-bottom: 0px;\n\t\t// :host(.item-label-stacked) {\n\t\t// }\n\t\t&.has-error {\n\t\t\tcolor: #ef5231;\n\t\t}\n\t}\n}\n\n.delete-promo {\n\tmargin-left: 5px;\n}\n\n.submit-button {\n\tbackground: var(--ion-color-secondary);\n\tborder-radius: 4px;\n\tplace-self: center;\n\tmargin: 0;\n}\n\n.reg-row {\n\twidth: 100%;\n\tcolor: var(--ion-color-secondary);\n\n\t&__btn {\n\t\tflex: 1;\n\t\tborder-radius: 5px;\n\t\tfont-size: 16px;\n\t\tpadding: 10px;\n\t\ttext-align: center;\n\t\tcursor: pointer;\n\n\t\t&:first-child {\n\t\t\tmargin-right: 8px;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tmargin-left: 8px;\n\t\t}\n\t}\n}\n\nion-spinner {\n\tdisplay: block;\n\tmargin: 10px auto;\n}\n\n.promo-input {\n\t--padding-start: 20px;\n}\n\n.wraper_name {\n\tpadding-bottom: 15px;\n\tborder-bottom: 2.55px dotted black;\n\tmargin-bottom: 10px;\n\n\t.name {\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t}\n\n\t.discount {\n\t\tfont-family: SecondFontBold, sans-serif;\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t}\n}\n\n.title {\n\tfont-family: AppFontBold;\n\tfont-size: 14px;\n\tline-height: 15px;\n\n\ttext-align: left;\n\tcolor: #000;\n}\n\n.promo-icon-button {\n\theight: 20px;\n\twidth: 20px;\n\tpadding: 5px;\n\tborder: 2px solid red;\n}\n.border-line {\n\tborder: 1px solid #000000;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
